import React from 'react';

import { SortableContainer } from 'react-sortable-hoc';

import SortableQuestionItem from '../SortableQuestionItem';

const SortableQuestionsList = SortableContainer(({ questions, onRemove }) => (
  <div className="sortable-questions-list">
    {questions.map((question, index) => (
      <SortableQuestionItem
        key={question.id}
        index={index}
        question={question}
        onRemove={onRemove}
      />
    ))}
  </div>
));

export default SortableQuestionsList;
